import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://landscapes.valeter.net';
const SITE_NAME = 'Landscape and Nature Photography by ValeTer';
const PHOTOGRAPHER_NAME = 'Valerii Tereshchenko (ValeTer)';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

const SEO = ({
    title,
    description,
    image,
    type = 'website',
    keywords,
    noindex = false,
    structuredData,
}) => {
    const location = useLocation();
    const canonicalUrl = `${SITE_URL}${location.pathname}`;
    
    const fullTitle = title 
        ? `${title} | ${SITE_NAME}`
        : `${SITE_NAME} | ${PHOTOGRAPHER_NAME}`;
    
    const fullDescription = description ||
        `Explore stunning landscape and nature photography by ${PHOTOGRAPHER_NAME}, capturing the beauty of the Pacific Northwest and beyond.`;
    
    const ogImage = image || DEFAULT_IMAGE;
    const fullImageUrl = ogImage.startsWith('http') ? ogImage : `${SITE_URL}${ogImage}`;

    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={fullDescription} />
            {keywords && <meta name="keywords" content={keywords} />}
            {noindex && <meta name="robots" content="noindex, nofollow" />}
            <link rel="canonical" href={canonicalUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={fullDescription} />
            <meta property="og:image" content={fullImageUrl} />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:locale" content="en_US" />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={fullDescription} />
            <meta name="twitter:image" content={fullImageUrl} />
            <meta name="twitter:creator" content="@ValeTer_" />

            {/* Structured Data (JSON-LD) */}
            {structuredData && (
                Array.isArray(structuredData) ? (
                    structuredData.map((data, index) => (
                        data && (
                            <script key={index} type="application/ld+json">
                                {JSON.stringify(data)}
                            </script>
                        )
                    ))
                ) : (
                    <script type="application/ld+json">
                        {JSON.stringify(structuredData)}
                    </script>
                )
            )}
        </Helmet>
    );
};

export default SEO;

